import React from 'react'
import { connect } from 'react-redux';
import { setCamera } from '../EventMedia/actions';
import { CameraType } from '../../../../data/media';

import PropTypes from 'prop-types';
import LiveMediaImage from './LiveMediaImage';
import EventMediaControl from './../EventMedia/EventMediaControl';
import imageCamToggle from './../EventMedia/images/cam-toggle-w64.svg';
import imageFullscreen from './../EventMedia/images/fullscreen-w64.svg';
import imageLiveStream from './../EventMedia/images/live-stream-w64.svg';
import {EVENT_MEDIA_CAMERA_TYPE} from '../EventMedia/eventMediaConstants';
import Events from 'APP_ROOT/components/common/events';
import { strings } from 'APP_ROOT/localization';

import { requestEventMediaFullscreen } from '../EventMedia/EventMedia';

class LiveMedia extends React.PureComponent {

    fullscreenElementRef = React.createRef();

    constructor(props){

        super(props);
        this.state = {
            paused: false
        };

        document.addEventListener(Events.PAUSE_DFAST, this.pauseEventHandler);
        document.addEventListener(Events.UNPAUSE_DFAST, this.unpauseEventHandler);

    }

    componentWillUnmount() {
        document.removeEventListener(Events.PAUSE_DFAST, this.pauseEventHandler);
        document.removeEventListener(Events.UNPAUSE_DFAST, this.unpauseEventHandler);
    }

    pauseEventHandler = () => {
        this.setPauseState(true);
    }

    unpauseEventHandler = () => {
        this.setPauseState(false);
    }

    setPauseState = (pauseState) => {
        this.setState({paused: pauseState});
    }

    toggleCamera = (e) => {
        this.props.toggleCamera(this.props.cameraType);
    }

    onLiveStream = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
        return this.props.onLiveStream(this.props.cameraType);
    }

    render() {

        var previewImageData;
        var date;

        if (this.props.cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
            previewImageData = this.props.roadCamera.image;
            date = this.props.roadCamera.date;
        } else {
            previewImageData = this.props.cabinCamera.image;
            date = this.props.cabinCamera.date;
        }

        return (
            <div className="col-12 image-panel panel-wrapper">
                <div className="row section-wrapper event-image">
                    <div className="col-12 section-body">
                        <div className="event-media-wrapper-16-9-aspect-ratio" ref={this.fullscreenElementRef}>

                                { this.state.paused ?
                                    <div className="pause-overlay">
                                        <div>
                                            <h2>{strings.formatString(strings.pausescreen_title)}</h2>
                                            <p>{strings.formatString(strings.pausescreen_m1)}</p>
                                            <p>{strings.formatString(strings.pausescreen_m2)}</p>
                                        </div>
                                    </div> : null 
                                }
                            
                                <div className="event-media-wrapper">
                                    <LiveMediaImage
                                        previewImageData = {previewImageData}
                                        date = {date}
                                    />

                                    <div className="event-media-controls">
                                        <EventMediaControl
                                            id="EVENT_MEDIA_CONTROL_STREAM"
                                            iconSrc={imageLiveStream}
                                            render={true}
                                            onClick={this.onLiveStream}
                                            disabled={(this.props.unplugged || this.props.offline) && strings.streaming_error_no_connection_message}
                                        />
                                        <EventMediaControl
                                            id="EVENT_MEDIA_CONTROL_FULLSCREEN"
                                            iconSrc={imageFullscreen}
                                            render={true}
                                            onClick={() => {requestEventMediaFullscreen(this.fullscreenElementRef)}}
                                        />
                                        <EventMediaControl
                                            id="EVENT_MEDIA_CONTROL_CAMERA_TOGGLE"
                                            iconSrc={imageCamToggle}
                                            render={true}
                                            onClick={this.toggleCamera}
                                        />
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LiveMedia.propTypes = {
    shouldShowAlternateCameraType: PropTypes.bool,
    roadCamera: PropTypes.shape({
        image: PropTypes.oneOfType([
            PropTypes.object, // image data src
            PropTypes.string  // or image url src
        ]),
        date: PropTypes.instanceOf(Date)
    }),
    cabinCamera: PropTypes.shape({
        image: PropTypes.oneOfType([
            PropTypes.object, // image data src
            PropTypes.string  // or image url src
        ]),
        date: PropTypes.instanceOf(Date)
    }),
    unplugged: PropTypes.bool,
    offline: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    // determine the current default/selected camera type
    let cameraType = state.scenes.dashboard.EventMedia.cameraType;
    // if this component should show the alternate camera, change this cameraType to show alternate
    if (ownProps.shouldShowAlternateCameraType) {
        if (cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
            cameraType = EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN;
        } else {
            cameraType = EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD;
        }
    }
    return {
        cameraType: cameraType
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        toggleCamera: (cameraTypeForComponent) => {
            let currentCamera = cameraTypeForComponent;
            // check if component is showing the alternate camera
            // ASSUMPTION: the toggle request should always be for the non-alternate camera type
            if (ownProps.shouldShowAlternateCameraType) {
                if (currentCamera === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                    currentCamera = EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN;
                } else {
                    currentCamera = EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD;
                }
            }
            dispatch(setCamera(currentCamera === CameraType.CAMERA_ROAD ? CameraType.CAMERA_CABIN : CameraType.CAMERA_ROAD));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveMedia);
